import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles, useTheme } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';
import { MouraLogo, MouraLogoIcon } from './MouraLogo';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();
  const theme = useTheme();

  // Verifica se o tema atual é o da Moura comparando a cor primária
  const isMoura = theme.palette.primary.main === '#003399';

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isMoura ? (
          isOpen ? <MouraLogo /> : <MouraLogoIcon />
        ) : (
          isOpen ? <LogoFull /> : <LogoIcon />
        )}
      </Link>
    </div>
  );
};
